// extracted by mini-css-extract-plugin
export default {"column":"ScoopColumn_column__yDwtr"};